var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6665 72.8333V26.8333M53.6665 72.8333H61.3332M53.6665 72.8333H34.4998M53.6665 26.8333C53.6665 18.365 46.8015 11.5 38.3332 11.5H22.9998C14.5315 11.5 7.6665 18.365 7.6665 26.8333V57.5C7.6665 64.65 12.5604 70.657 19.1812 72.3541M53.6665 26.8333H65.9681C67.9159 26.8333 69.7906 27.5747 71.2116 28.9069L81.9101 38.9367C83.456 40.386 84.3332 42.4106 84.3332 44.5298V65.1667C84.3332 69.4008 80.9007 72.8333 76.6665 72.8333M76.6665 72.8333C76.6665 77.0675 73.234 80.5 68.9998 80.5C64.7657 80.5 61.3332 77.0675 61.3332 72.8333M76.6665 72.8333C76.6665 68.5991 73.234 65.1667 68.9998 65.1667C64.7657 65.1667 61.3332 68.5991 61.3332 72.8333M34.4998 72.8333C34.4998 77.0675 31.0674 80.5 26.8332 80.5C22.599 80.5 19.1665 77.0675 19.1665 72.8333C19.1665 72.6724 19.1715 72.5126 19.1812 72.3541M34.4998 72.8333C34.4998 68.5991 31.0674 65.1667 26.8332 65.1667C22.76 65.1667 19.4286 68.3431 19.1812 72.3541",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3332 30.6667H30.6665",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3333 46H23",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.4e3e7203ca9d412493165c8ae82025af.svg";
export { ForwardRef as ReactComponent };